export default __webpack_public_path__ + "static/media/jeema-logo.5cf06028.jpeg";